var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ieExpro"}},[_c('a-row',[_c('a-col',{attrs:{"span":11}},[_c('t-asn')],1),_c('a-col',{attrs:{"span":11}},[_c('h-so')],1)],1),_c('a-row',[_c('p-po')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }